/**
 * Device capability helpers
 */

/** True for devices with a precise pointer and hover (mouse/trackpad) */
export function hasFinePointer(): boolean {
  if (typeof window === 'undefined' || !window.matchMedia) return true;
  return window.matchMedia('(hover: hover) and (pointer: fine)').matches;
}
